
import styled from "styled-components";
import { ButtonIcon } from "@loanbossinc/component-library";

export const PageContainer = styled.div`&&{}`;

export const TitleBar = styled.div`&& {
  font-size: 24px;
  marign-top: 25px;
  margin-bottom: 30px;
}`;

export const ModuleWrapper = styled.div`&& {
  font-size: 20px;
  margin-top: 25px;
  color: #888888;
}`;

export const TitleWrapper = styled.div`&& {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  /* Module / Category */
  width: 648px;
  height: 72px;
  padding-top: 27px; 
  padding-bottom: 27px;    


  /* Fill / Gray */    
  background: #FAFAFA;

  /* Stroke / Gray */    
  border: 1px solid #DADCE0;
  box-sizing: border-box;
  border-radius: 8px 8px 0px 0px;

  .button{
    margin-right: 24px;
  }

  .title {
    /* Category With Sections */
    height: 19px;
    padding-left: 24px;
    padding-right: 24px;

    /* Work Sans / 16 Medium */

    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    /* identical to box height */
    
    display: flex;
    align-items: center;
    
    /* Text / Black */
    
    color: #000000;
  }
}`;

export const RowWrapper = styled.div`&& {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap
  height: 60px;
  background: #FFFFFF;    
  border-left: 1px solid #DADCE0;
  border-right: 1px solid #DADCE0;
  border-bottom: 1px solid #DADCE0;
  padding: 1em;
  .text {
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    color: #000000;
  }
  .red {
    color: #FF0000
  }
}`;

export const TextWrapper = styled.div`
  width: 85%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1em;
  flex-wrap: wrap;
`;

export const ButtonWrapper = styled.div`&& {
  width: 15%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 1em;
}`;

export const Module = styled.div`&& {
  margin-left: 24px;
  width: 648px;
}`;

export const StyledButtonIcon = styled(ButtonIcon)`{
  color: #C40A0A;
}`;
